import React, {Component} from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import {withRouter, Link} from "react-router-dom";
import {withTranslation} from "react-i18next";
import {format} from "react-string-format";
import * as url from "../../../api/url";
import {getUser} from "../../../common/general";

const getUserName = () => {
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"))
    return obj.user.username;
  }
}

class ProfileMenu extends Component {
  constructor(props) {
    super(props)
    this.state = {
      menu: false,
      name: getUserName(),
    }
    this.toggle = this.toggle.bind(this)
  }

  toggle() {
    this.setState(prevState => ({
      menu: !prevState.menu,
    }))
  }

  render() {
    return (
      <React.Fragment>
        <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block">
          <DropdownToggle className="btn header-item" id="page-header-user-dropdown" tag="button">
            <img className="rounded-circle header-profile-user" src={format(url.DIRECT_AVATAR, getUser().user.id)} alt="Header Avatar"/>{" "}
            <span className="d-none d-xl-inline-block ms-1">
              {this.state.name}
            </span>
            <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
          </DropdownToggle>
          <DropdownMenu className="dropdown-menu-end">
            <DropdownItem tag="a" href="/profile">
              <i className="bx bx-user font-size-16 align-middle me-1"/>
              {this.props.t("Profile")}
            </DropdownItem>
            <DropdownItem tag="a" href="/settings">
              <i className="bx bx-wrench font-size-16 align-middle me-1"/>
              {this.props.t("Settings")}
            </DropdownItem>
            <div className="dropdown-divider"/>
            <Link to="/logout" className="dropdown-item">
              <i className="bx bx-power-off font-size-16 align-middle me-1 text-danger"/>
              <span>{this.props.t("Logout")}</span>
            </Link>
          </DropdownMenu>
        </Dropdown>
      </React.Fragment>
    )
  }
}

export default withRouter(withTranslation()(ProfileMenu))
